import * as React from 'react';

export class MarkupsLabel extends React.PureComponent {
  render() {
    return <div className="markupslayer-label-container aligned">Markups</div>;
  }
}
